<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de Campañas</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cat-escalas-nuevo', params: {} }"
              >
                <i class="fa fa-pencil"></i>
                Nueva campaña
              </router-link>
            </div>
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <UsuariosSelectComponent
                  titulo=""
                  class="col-sm-3"
                  style="display: block"
                  :current="filter"
                  @change="filterData()"
                  @onChange="filterData()"
                />
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar número"
                  v-model="filter.numero"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Nombre o descripción"
                  v-model="filter.searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <EscalasTableComponent :dataTabla="datatabla2" />
        <PaginationComponent
          :currentPage="currentPage"
          :data="datatabla2"
          @pagechanged="filterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import EscalasTableComponent from "@/components/cat/escalas/EscalasTableComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    EscalasTableComponent,
    UsuarioEnTablaComponent,
    UsuariosSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      datatabla2: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        fecha_creacion: "",
        numero: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    this.refreshData();
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    $("#modalTiendaSelect").modal("show");
  },
  methods: {
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    refreshData() {
      DynamicService.fetch("cat", "campana-ofertas", {}).then((response) => {
        this.datatabla2 = response.data;
      });
    },
    filterData(page) {
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("cat", "campana-ofertas", {
        page: this.$data.currentPage,
        "filter[search]": this.filter.searchtext,
        fecha_creacion: this.filter.fecha_creacion,
        usuario: this.filter.usuario.id,
        id: this.filter.numero,
      }).then((response) => {
        this.datatabla2 = response.data;
        $("#modalTiendaSelect").modal("hide");
      });
    },
    clearFilterData() {
      this.filter.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.numero = "";
      this.filter.usuario = "";
      this.filter.tienda = "";
      this.refreshData();
    },
  },
};
</script>